
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { css } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var label = function label(_ref, _ref2) {
  var typeScaleSizes = _ref.typeScaleSizes;
  var size = _ref2.size;
  var fontSizes = {
    md: typeScaleSizes.sm,
    lg: typeScaleSizes.md
  };
  return /*#__PURE__*/ /*#__PURE__*/css("font-size:", fontSizes[size], ";font-weight:700;display:block;margin:0 0 0.5rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:label;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZWSIsImZpbGUiOiJzdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIFRoZW1lLCBTZXJpYWxpemVkU3R5bGVzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0XCI7XG5pbXBvcnQgeyBMYWJlbFNpemUgfSBmcm9tIFwiLi9MYWJlbFwiO1xuXG5leHBvcnQgY29uc3QgbGFiZWwgPSAoXG4gIHsgdHlwZVNjYWxlU2l6ZXMgfTogVGhlbWUsXG4gIHsgc2l6ZSB9OiB7IHNpemU6IExhYmVsU2l6ZSB9LFxuKTogU2VyaWFsaXplZFN0eWxlcyA9PiB7XG4gIGNvbnN0IGZvbnRTaXplcyA9IHtcbiAgICBtZDogdHlwZVNjYWxlU2l6ZXMuc20sXG4gICAgbGc6IHR5cGVTY2FsZVNpemVzLm1kLFxuICB9O1xuXG4gIHJldHVybiBjc3NgXG4gICAgZm9udC1zaXplOiAke2ZvbnRTaXplc1tzaXplXX07XG4gICAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgICBkaXNwbGF5OiBibG9jaztcbiAgICBtYXJnaW46IDAgMCAwLjVyZW07XG4gIGA7XG59O1xuIl19 */", process.env.NODE_ENV === "production" ? "" : ";label:label;");
};

export { label };
//# sourceMappingURL=styles.js.map
